import React from "react";
import { Styleable } from "../../types";

interface PinProps extends Styleable {
  direction: string;
  width?: number;
  height?: number;
  number?: number;
}

export default function StoreyPin({ direction, width = 20, height = (width / 29) * 46 }: PinProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 22 35"
      fill="none"
    >
      <g filter="url(#filter0_d)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.9999 29.9996C13.6413 29.9996 15.7825 30.5898 15.7825 31.3178C15.7825 32.0458 13.6413 32.636 10.9999 32.636C8.35853 32.636 6.21729 32.0458 6.21729 31.3178C6.21729 30.5898 8.35853 29.9996 10.9999 29.9996Z"
          fill="white"
          fillOpacity="0.01"
        />
      </g>
      <mask
        id="path-2-outside-1"
        maskUnits="userSpaceOnUse"
        x="0"
        y="-0.000244141"
        width="22"
        height="32"
        fill="black"
      >
        <rect fill="white" y="-0.000244141" width="22" height="32" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 29.9998C11 29.9998 21 16.851 21 11.2113C21 5.57162 16.5228 0.999756 11 0.999756C5.47715 0.999756 1 5.57162 1 11.2113C1 16.851 11 29.9998 11 29.9998Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 29.9998C11 29.9998 21 16.851 21 11.2113C21 5.57162 16.5228 0.999756 11 0.999756C5.47715 0.999756 1 5.57162 1 11.2113C1 16.851 11 29.9998 11 29.9998Z"
        fill="#E87E2C"
      />
      <path
        d="M11 29.9998L10.204 30.6051L11 31.6517L11.796 30.6051L11 29.9998ZM11 29.9998C11.796 30.6051 11.7961 30.605 11.7962 30.6048C11.7963 30.6047 11.7965 30.6044 11.7967 30.6042C11.797 30.6037 11.7976 30.603 11.7983 30.6021C11.7997 30.6002 11.8016 30.5976 11.8042 30.5942C11.8093 30.5875 11.8168 30.5775 11.8267 30.5646C11.8463 30.5386 11.875 30.5004 11.9124 30.4506C11.9871 30.351 12.096 30.205 12.2343 30.0175C12.5109 29.6427 12.9052 29.102 13.378 28.4359C14.3228 27.1048 15.5843 25.2683 16.8475 23.2512C18.1086 21.2374 19.3828 19.0255 20.345 16.9462C21.2905 14.9032 22 12.8542 22 11.2113H20C20 12.3882 19.4595 14.0977 18.53 16.1062C17.6172 18.0786 16.3914 20.2113 15.1525 22.1897C13.9157 24.1647 12.6772 25.9679 11.747 27.2783C11.2823 27.9331 10.8953 28.4637 10.625 28.83C10.4899 29.0131 10.384 29.155 10.3122 29.2508C10.2763 29.2987 10.249 29.335 10.2307 29.3592C10.2216 29.3712 10.2148 29.3803 10.2103 29.3862C10.2081 29.3891 10.2064 29.3913 10.2054 29.3927C10.2048 29.3933 10.2045 29.3938 10.2043 29.3941C10.2041 29.3943 10.2041 29.3943 10.204 29.3944C10.204 29.3944 10.204 29.3944 11 29.9998ZM22 11.2113C22 5.03917 17.0948 -0.000244141 11 -0.000244141V1.99976C15.9509 1.99976 20 6.10406 20 11.2113H22ZM11 -0.000244141C4.90524 -0.000244141 0 5.03917 0 11.2113H2C2 6.10406 6.04907 1.99976 11 1.99976V-0.000244141ZM0 11.2113C0 12.8542 0.709512 14.9032 1.65497 16.9462C2.61721 19.0255 3.8914 21.2374 5.15247 23.2512C6.41567 25.2683 7.67719 27.1048 8.62204 28.4359C9.09479 29.102 9.48906 29.6427 9.76567 30.0175C9.90399 30.205 10.0129 30.351 10.0876 30.4506C10.125 30.5004 10.1537 30.5386 10.1733 30.5646C10.1832 30.5775 10.1907 30.5875 10.1958 30.5942C10.1984 30.5976 10.2004 30.6002 10.2017 30.6021C10.2024 30.603 10.203 30.6037 10.2033 30.6042C10.2035 30.6044 10.2037 30.6047 10.2038 30.6048C10.2039 30.605 10.204 30.6051 11 29.9998C11.796 29.3944 11.796 29.3944 11.796 29.3944C11.7959 29.3943 11.7959 29.3943 11.7957 29.3941C11.7955 29.3938 11.7952 29.3933 11.7946 29.3927C11.7936 29.3913 11.7919 29.3891 11.7897 29.3862C11.7852 29.3803 11.7784 29.3712 11.7693 29.3592C11.751 29.335 11.7237 29.2987 11.6878 29.2508C11.616 29.155 11.5101 29.0131 11.375 28.83C11.1047 28.4637 10.7177 27.9331 10.253 27.2783C9.32281 25.9679 8.08433 24.1647 6.84753 22.1897C5.6086 20.2113 4.38279 18.0786 3.47003 16.1062C2.54049 14.0977 2 12.3882 2 11.2113H0Z"
        fill="white"
        mask="url(#path-2-outside-1)"
      />
      {direction === "up" ? (
        <>
          <path d="M15.5 7.5L7.5 15.5" stroke="white" strokeWidth="2" strokeMiterlimit="10" />
          <path d="M10.5 7.5L15.5 7.5V12.5" stroke="white" strokeWidth="2" strokeMiterlimit="10" />
        </>
      ) : (
        <>
          <path
            d="M15.5 7.49976L7.5 15.4998"
            stroke="white"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            d="M12.5 15.4998H7.5V10.4998"
            stroke="white"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
        </>
      )}
      <defs>
        <filter
          id="filter0_d"
          x="4.21729"
          y="27.9996"
          width="13.5652"
          height="6.63636"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}
